import { render, staticRenderFns } from "./ReportBackground.vue?vue&type=template&id=1d370b1b&"
import script from "./ReportBackground.vue?vue&type=script&lang=ts&"
export * from "./ReportBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports